import { configureStore } from '@reduxjs/toolkit';
import modalSlice from './slices/modalSlice';

// Example reducer (replace with your own reducers)

const store = configureStore({
    reducer: {
        modal: modalSlice,
    },
});

export default store;
